import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import SecondLayout from "../layouts/SecondLayout";
import AboutMeBody from "../components/partials/AboutMe/AboutMeBody";
import { Variables } from "../variables";

const AboutMe = () => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [content, setContent] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const url =
          Variables.API_URL +
          "Rasha/Client/Page/6?isEnglish=" +
          (language === "en");

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          signal: controller.signal,
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result?.message || "Failed to fetch content");

        if (isMounted) setContent(Array.isArray(result) ? result : []);
      } catch (err) {
        if (isMounted && err.name !== "AbortError") {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [language]);

  if (loading) {
    return (
      <div style={styles.loaderWrap}>
        <div style={styles.spinner} />
      </div>
    );
  }

  if (error) {
    return <div style={styles.errorBox}>{error}</div>;
  }

  const widget = content?.[0]?.WidgetValue;
  const title = language === "en" ? widget?.Title : widget?.TitleAr;
  const body = language === "en" ? widget?.Body : widget?.BodyAr;

  return (
    <SecondLayout>
      <div className="container">
        <h2 className="about-me-title">{title || ""}</h2>
      </div>
      <AboutMeBody language={language} body={body || ""} />
    </SecondLayout>
  );
};

const styles = {
  loaderWrap: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  spinner: {
    width: 48,
    height: 48,
    border: "4px solid rgba(0,0,0,0.1)",
    borderTopColor: "#000",
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  },
  errorBox: {
    margin: 16,
    padding: "12px 16px",
    border: "1px solid #f3c2c2",
    background: "#fff5f5",
    color: "#b00020",
    borderRadius: 8,
  },
};

// inject keyframes (once, unique id for this page)
if (typeof document !== "undefined" && !document.getElementById("blogs-spin-kf")) {
  const styleEl = document.createElement("style");
  styleEl.id = "blogs-spin-kf";
  styleEl.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
  document.head.appendChild(styleEl);
}

export default AboutMe;
